module.exports = __webpack_public_path__ + "media/dark-samus.493f2805.wav";